<template>
  <div :class="['product-card pc__wrapper', {'collection': showOptionDetails}, {'atcDetails': showATCDetails}]">
    <a :href="`/products/${product.handle}`" class="product-card_media">
      <transition name="fade" mode="out-in">
        <ImageField
          :key="featureImages.length ? featureImages[0].src : selectedVariant.featured_image" 
          :obj="{  
            'url': featureImages.length ? featureImages[0].src : selectedVariant.featured_image, 
            'alt': featureImages.length ? featureImages[0].alt : 'feature image', 
            'width': 800, 
            'height': 800
          }"
          sizes="(max-width: 767px) 50vw, 400px"
        />
      </transition>
    </a>
    <div class="product-card_content">
      <div class="product-card_info">
        <a :href="`/products/${product.handle}`" class="product-card_title">
          <span>
            {{ product.title || product.product_title }}
          </span>
        </a>
        
        <div class="product-card_price">  
          <span v-if="!isBundleGeneric" class="product-card_price-subscription">{{ subscriptionPrice ? subscriptionPrice : formatPrice(selectedVariant.price) }}</span>
          <span v-if="isBundleGeneric" class="product-card_price-subscription">{{ bundleCardPrice }}</span>
          <span v-if="!isBundleGeneric" class="product-card_price-otp hide">{{ formatPrice(selectedVariant.price) }}</span>
          <s class="text-sm text-error" v-if="selectedVariant.compare_at_price > 0">
            <span class="mobile-text-base">{{ formatPrice(selectedVariant.compare_at_price) }}</span>
          </s>
        </div>
        
        <div class="product-card_reviews">
          <div class="yotpo bottomLine" data-appkey="SmtoQBJliJwFrBjSYjmEtOz31o6nMoLZfgcp3J4j" :data-product-id="product.id"></div>
          <!--<svg class="icon"><use href="#star-filled"></use></svg>-->
        </div>
        
        <div v-if="variantTitle" class="product-card_variants">
          <div class="product-card_variant" :class="{'mobile-text-base' : !showOptionDetails}">
            {{ variantTitle }}
          </div>
        </div>
        
      </div>
    </div>
    <div v-if="isFeatureTag" class="product-card_tag" :style=" { '--bg-tag': isFeatureTag.color }">
        {{ isFeatureTag.name }}
    </div>
    <div class="product-card_form-wrapper">
      <a :href="`/products/${product.handle}`" class="product-card_form-product-link">
      </a>

      <button v-if="!showOptionDetails" @click="onATC()" class="btn--add-to-cart" :disabled="!selectedVariant.available || selectedVariant.sold_out" type="button" aria-label="Add product to cart">
        <svg class="icon"><use href="#cart-plus"></use></svg>
      </button>
      <button v-else @click="onATCCollection(true)" class="btn--add-to-cart" type="button" aria-label="Add product to cart">
        <svg class="icon"><use href="#cart-plus"></use></svg>
      </button>
    </div>
    <div v-if="showATCDetails" @click="onATCCollection(false)" class="pc__option-overlay"></div>
    <div v-if="showATCDetails" :id="product.id" class="pc__option-wrapper buybox__content">
      <div class="pc__title-wrapper">
        <h2 class="h5-sans">{{ product.title || product.product_title }}</h2>
        <button @click="onATCCollection(false)" class="pc__option-close">
          <svg class="icon icon--xl">
            <use href="#x"></use>
          </svg>
        </button>
      </div>
      <BuyboxBundle v-if="isBundleSingleProduct"
        :product="product"
        :selectedVariant="selectedVariant"
        :isSubscription="buyboxSubscription?.isSubscription"
        :isStayBundle="isStayBundle"
        @update-option="onUpdateOption"
      />
      <BuyboxBundleGeneric v-if="isBundleGeneric"
        :product="product"
        :selectedVariant="selectedVariant"
        :isSubscription="buyboxSubscription?.isSubscription"
        :isStayBundle="isStayBundle"
        @update-option="onUpdateOption"
        @update-card-price="onUpdateCardPrice"
      />
      <BuyboxOptions
        :product="product"
        :selectedVariant="selectedVariant"
        :isDropdown="false"
        :isStayBundle="isStayBundle"
        :isOneFlavorBuybox="Boolean(true)"
        @update-option="onUpdateOption"
      />
      <BuyboxSubscription 
        ref="buyboxSubscription"
        :product="product"
        :selectedVariant="selectedVariant"
        :isMultiPack="isMultiPack"
        :selectedSellingPlan="selectedSellingPlan"
        :isStayBundle="isStayBundle"
        :isOneFlavorBuybox="Boolean(true)"
        @update-option="onUpdateOption"
        @update-selling-plan="onUpdateSellingPlan"
        @update-is-subscription="onUpdateIsSubscription"
      />
      <BuyboxATC
        :isMultiPack="isMultiPack"
        :isSubscription="buyboxSubscription?.isSubscription"
        :selectedVariant="selectedVariant"
        :selectedSellingPlan="selectedSellingPlan"
        :isStayBundle="isStayBundle"
        @toggle-option-drawer="toggleOptionDrawer"
      />
      <a :href="`/products/${product.handle}`" class="pc__details text-sm">View full details</a>
    </div>

    <div :id="product.id" class="buybox__content generic-bundle-price-calulation">
      <BuyboxBundleGeneric
        v-if="isBundleGeneric && !hasPrecalculatedPrice"
        :product="product"
        :selectedVariant="selectedVariant"
        :isSubscription="buyboxSubscription?.isSubscription"
        :isStayBundle="isStayBundle"
        @update-card-price="onFirstPriceCalculated"
      />
      <BuyboxSubscription 
        v-if="isBundleGeneric && !hasPrecalculatedPrice"
        ref="buyboxSubscription"
        :product="product"
        :selectedVariant="selectedVariant"
        :isMultiPack="isMultiPack"
        :selectedSellingPlan="selectedSellingPlan"
        :isStayBundle="isStayBundle"
        :isOneFlavorBuybox="Boolean(true)"
        @update-option="onUpdateOption"
        @update-selling-plan="onUpdateSellingPlan"
        @update-is-subscription="onUpdateIsSubscription"
      />
      <BuyboxATC
        v-if="isBundleGeneric && !hasPrecalculatedPrice"
        :isSubscription="buyboxSubscription?.isSubscription"
        :selectedVariant="selectedVariant"
        :selectedSellingPlan="selectedSellingPlan"
        :isStayBundle="isStayBundle"
        @toggle-option-drawer="toggleOptionDrawer"
      />
    </div>
  </div>
</template>

<script setup>
  import { computed, toRefs, ref, onBeforeMount } from 'vue';
  import ImageField from '../global/image.vue';
  import BuyboxBundle from '../buybox/components/buybox-bundle.vue';
  import BuyboxBundleGeneric from '../buybox/components/buybox-bundle-generic.vue';
  import BuyboxOptions from '../buybox/components/buybox-options.vue';
  import BuyboxSubscription from '../buybox/components/buybox-subscription.vue';
  import BuyboxATC from "../buybox/components/buybox-atc.vue";

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({})
    },

    showOptionDetails: {
      type: Boolean,
      default: false
    },

    isStayBundle: {
      type: Boolean,
      default: false, 
    }
  })

  const { product, showOptionDetails } = toRefs(props);
  const multiPackOptions = ['boxes', 'tubs', 'bottles'];
  const showATCDetails = ref(false);
  const selectedVariant = ref(null);
  const selectedSellingPlan = ref(null);
  const buyboxSubscription = ref(null);

  onBeforeMount(() => {
    initialSetup();
  })

  const isStayBundle = computed(() => {
    return product.value.template.includes('bundle') ? true : false;
  })

  const isBundleSingleProduct = computed(() => {
    return product.value.template === 'bundle' ? true : false;
  })

  const isBundleGeneric = computed(() => {
    return product.value.template === 'bundle-generic' ? true : false;
  })

  const bundleCardPrice = ref('')
  const hasPrecalculatedPrice = ref(false)

  const onUpdateCardPrice = (price) => {
    bundleCardPrice.value = price
  }

  const onFirstPriceCalculated = (price) => {
    onUpdateCardPrice(price)
    hasPrecalculatedPrice.value = true
  }

  const isMultiPack = computed(() => {
    return product.value.options.some(option => multiPackOptions.includes(option.name.toLowerCase()));
  });

  const featureImages = computed(() => {
    const { images, options } = product.value;
    
    const firstOption = (options.find(option => option.position === 1) || null);
    const secondOption = (options.find(option => option.position === 2) || null);
    const imgPattern = imagePattern(firstOption, secondOption);
    const matchingImages = images.filter(image => imgPattern.test(image.alt));
    const imagesWithLast = matchingImages.filter(image => /\/last$/i.test(image.alt));
    const imagesWithoutLast = matchingImages.filter(image => !/\/last$/i.test(image.alt));

    return [...imagesWithoutLast, ...imagesWithLast];
  });

  const isFeatureTag = computed(() => {
    return selectedVariant.value?.feature_tag;
  })

  const variantTitle = computed(() => {
    const { options } = product.value || {};
    let title = '';

    options?.forEach((option, index) => {
      const optionName = option.name.toLowerCase();
      const isFlavorOption = optionName.includes('flavor');
      const isSizeOption = optionName.includes('size');

      if (isFlavorOption) {
        const flavorCount = option.values.length;
        if (flavorCount === 1) {
          if(option.values[0] !== 'Unflavored') {
            title += '1 flavor';
          }   
        } else {
          title += `${flavorCount} flavors`;
        }
      } else if (isSizeOption) {
        const servingText = `${option.selected} servings`;
        if (option.position === 1 || (options[0].values[0] === 'Unflavored')) {
          title += servingText;
        } else {
          title += ` / ${servingText}`;
        }
      }
    });

    return title.trim();
  });

  const compareAtPrice = computed(() => {
    var item = selectedVariant.value || product.value.variants[0]
    return item.compare_at_price > 0 ? window.formattedPrice(item.compare_at_price/100) : null;
  })

  const getFormattedPrice = (price, sellingPlans) => {
    if (window.shopLocation !== 'GB' && isMultiPack.value) {
      return window.formattedPrice(price / 100);
    } else {
      const sellingPlan = sellingPlans.find(plan => plan.selling_plan.id === selectedSellingPlan.value.id);
      if (sellingPlan) {
        return window.formattedPrice((sellingPlan.per_delivery_price / 100).toFixed(2));
      }
      return window.formattedPrice((price / 100).toFixed(2));
    }
  }

  const subscriptionPrice = computed(() => {
    const { variants } = product.value;
    const item = selectedVariant.value || variants[0];

    if (item.has_subscription_plan) {
      return getFormattedPrice(item.price, item.selling_plans);
    } else {
      const availableSubscriptionVariant = subscriptionVariants(item)

      if (availableSubscriptionVariant) {
        const sellingPlan = availableSubscriptionVariant.selling_plans[0];
        emit('update-selling-plan', {
          name: sellingPlan.selling_plan.name,
          id: sellingPlan.selling_plan.id,
          discount_type: sellingPlan.selling_plan.price_adjustments[0]?.value_type || '',
          discount_value: sellingPlan.selling_plan.price_adjustments[0]?.value || 0
        }, false);
        return getFormattedPrice(availableSubscriptionVariant.price, availableSubscriptionVariant.selling_plans);
      } else {
        return null;
      }
    }
  })

  const initialSetup = () => {
    const { options, variants } = product.value;

    if (isMultiPack.value) {
      selectedVariant.value = variants.find(
        (variant) => variant.options[options.length - 1] === 'One Time Purchase'
      ) || variants[0];
    } else {
      selectedVariant.value = variants[0];
    }

    const plans = renderSubFrequency.value;

    selectedSellingPlan.value = plans?.length > 0 
      ? plans[0] 
      : (selectedVariant.value.has_subscription_plan 
          ? {
              name: selectedVariant.value.selling_plans[0].selling_plan.name,
              id: selectedVariant.value.selling_plans[0].selling_plan.id,
              discount_type: selectedVariant.value.selling_plans[0].selling_plan.price_adjustments[0]?.value_type,
              discount_value: selectedVariant.value.selling_plans[0].selling_plan.price_adjustments[0]?.value
            }
          : null);

    product.value.options.forEach((option, index) => {
      option.selected = selectedVariant.value.options[index];
    });
  }

  const renderSubFrequency = computed(() => {
    if(!selectedVariant.value.has_subscription_plan) return null;

    const selectedVariantFrequencies = selectedVariant.value.selling_plans.map(plan => ({
      id: plan.selling_plan.id,
      name: plan.selling_plan.name,
      discount_type: plan.selling_plan.price_adjustments[0]?.value_type || '',
      discount_value: plan.selling_plan.price_adjustments[0]?.value || 0
    }));

    return selectedVariantFrequencies.filter(option => {
      if (isStayBundle.value) {
        return option.discount_value === 25;
      } else if (!isStayBundle.value) {
        return option.discount_value === 20;
      } else {
        return true;
      }
    });
  })

  const subscriptionVariants = (variant) => {
    const { variants } = product.value;
    const item = selectedVariant.value || variants[0];
    const { options } = item;

    return variants.find(variant =>
      options.slice(0, options.length - 1).every((option, index) =>
        variant.options[index] === option
      ) && 
      variant.options[options.length - 1] !== 'One Time Purchase' &&
      (variant.selling_plans?.length ?? 0) > 0
    );
  }

  const updateSelectedVariant = (index) => {
    const { options, variants } = product.value;

    const selectedOptions = options.map(option => option.selected.toLowerCase());

    selectedVariant.value = variants.find(variant => {
      return variant.options.every((option, idx) => option.toLowerCase() === selectedOptions[idx]);
    });

    if(!selectedVariant.value && isMultiPack.value && options.length === 3) {
      const availableVariants = variants.filter(variant => {
        return variant.options[0] === options[0].selected && variant.options[1] === options[1].selected
      });

      if (availableVariants.length) {
        selectedVariant.value = availableVariants[0];
        options.forEach((option, index) => {
          option.selected = selectedVariant.value.options[index];
        });
      }
    }

    if(!selectedVariant.value.has_subscription_plan && buyboxSubscription.value) {
      buyboxSubscription.value.isSubscription = false;
    }
  };

  const onUpdateOption = (key,value, index) => {
    let tempSelectedOption = product.value.options[index].selected;
    product.value.options[index].selected = value;
    updateSelectedVariant(index);

    setTimeout(() => {
      if(key.toLowerCase() === 'size' && value == '20' && tempSelectedOption != value && buyboxSubscription.value) {
        buyboxSubscription.value.onSubscriptionChange(true)
      }
    })
  };

  const onUpdateSellingPlan = (value, isSubscription) => {
    selectedSellingPlan.value = value;

    if(isSubscription && buyboxSubscription.value) {
      buyboxSubscription.value.isSubscription = true;
    } 
  }

  const onUpdateIsSubscription = (value) => {
    if(buyboxSubscription.value) {
      buyboxSubscription.value.isSubscription = value;
    } 
  }

  const imagePattern = (firstOption, secondOption) => {
    const firstOptionLower = firstOption.selected.toLowerCase();
    const secondOptionLower = secondOption?.selected.toLowerCase();
    const commonPatterns = [`^${firstOptionLower}/all$`, `^${firstOptionLower}/all/last$`, `^all$`];

    const regexPattern = secondOption && !['boxes', 'tubs', 'bottles'].includes(secondOption.name.toLowerCase())
    ? [`^${firstOptionLower}/${secondOptionLower}$`, `^${firstOptionLower}/${secondOptionLower}/last$`, ...commonPatterns]
    : [`^${firstOptionLower}$`, `^${firstOptionLower}/last$`, ...commonPatterns];

    return new RegExp(regexPattern.join('|'), 'i');
  }

  const formatPrice = (price) => {
    return window.formattedPrice(price/100)
  }

  const onATC = async() => {
    window.openCart();
    await window.Additem({
      id: selectedVariant.value.id,
      quantity:1,
      ...(selectedSellingPlan.value) && {selling_plan: selectedSellingPlan.value.id}
    })
  }

  const onATCCollection = (value) => {
    let bodyStyle = document.body.style;
    showATCDetails.value = value;
    
    if(value) {
      bodyStyle.overflow = 'hidden' 
    }else {
      bodyStyle.overflow = 'auto' 
    }
  }

  const toggleOptionDrawer = () => {
    showATCDetails.value = false;
  }
</script>